import type { DashboardStats } from '@/types'
import { request, buildQueryString } from './client'

export async function getDashboardStats(
  showHidden: boolean = false,
  collapseVariants: boolean = false,
): Promise<DashboardStats> {
  const query = buildQueryString({ showHidden, collapseVariants })
  return request<DashboardStats>(`/dashboard${query}`)
}
